import {IntermediatePart} from "../../parts/intermediatePart";
import {Vanity} from "../../parts/vanity";
import store from "../../../../../store";
import {Layout} from "../../layout";

export default class VanityPedestal extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'vanity_cabinet';
    this.partName = 'Cabinet';
    this.translateId = "visualizer.bathroom.vanity.vanity_cabinet";
    this.dbName = "Vanity";
    this.homePageTitle = 'Vanity Bases';
    this.visible = [Vanity.Types.Custom];
    this.canBeDisabled = true;
    this.canUseWizard = true;
  }

  load(dbFeature) {
    return super.load_(dbFeature, new VanityPedestal())
  }

  // navigationSubItems() {
  //   return super.navigationSubItemsWithFilter('VanitySize', this.getParent().counterTopSize());
  // }

  disabledClick() {
    this.getParent().toggleVanityParts(this.disabled);
  }

  setActiveFeatureByFilter(filterName, filterValue) {

    // console.log('filterName', filterName);
    // console.log('filterValue', filterValue);

    const filterGroups = store.getState().filterState.filterGroups;
    const group = filterGroups.find(group => group.name === filterName);
    const groupId = group.id;
    const filterValueId = Layout.getfilterValueIdByValue(groupId, filterValue);
    const filteredFeatures = this.features.filter(
      feature => feature.dbFeature && feature.dbFeature.filterValueIDs[groupId] && feature.dbFeature.filterValueIDs[groupId].includes(filterValueId)
    );    // find among all features only those, who have filter with value === props size
    if (!super.tryToSetTheSameFeature(filteredFeatures, null, "ustom")) {
      this.activeFeature = filteredFeatures[0];
      const placeholderAvailableFeatures = filteredFeatures.filter(feature => {
        return feature.dbFeature.displayName.includes("laceholder") && feature.dbFeature.displayName.includes("ustom")
      });
      this.placeholderFeature = placeholderAvailableFeatures[0];
    }
  }

  // getAvailableFeatures() {
  //   return this.features.filter(f => f.vanitySize+'in' === this.getParent().counterTopSize());
  // }

  setDefault(layout) {
    super.setDefault(layout);
    const hardCodedDefault = this.features.find((feature) => {
      return +feature.vanitySize === 48
    });
    this.activeFeature = hardCodedDefault || super.setDefault(layout);
    this.placeholderFeature = this.features.find((feature) => {
      return +feature.vanitySize === 48
        && feature.dbFeature.displayName
        && feature.dbFeature.displayName.includes("laceholder")
        && feature.dbFeature.displayName.includes("ustom")
    }) || null;
  }

  setZIndex(zIndexes) {
    if (zIndexes && this.activeFeature) {
      this.activeFeature.layer.zIndex = zIndexes.Vanity.Custom.Cabinet;
    }
    if(zIndexes && this.placeholderFeature) {
      this.placeholderFeature.layer.zIndex = zIndexes.Vanity.Custom.Cabinet;
    }
  }
}
